<template>
    <div class="px-4 sm:px-6 lg:px-8 mx-auto flex justify-between items-start md:items-center gap-4">
        <div class="flex flex-col">
            <p class="text-xs font-semibold uppercase tracking-wide text-amber-600">Applicant Boost</p>
            <h1 class="font-semibold text-2xl leading-tight">{{ title }}</h1>
            <h2 class="text-xs">{{ subtitle }}</h2>
        </div>
        <div class="flex shrink-0 items-center gap-4">
            <slot />
            <inertia-link class="whiteButton" :href="route('reports.dashboard', reportId)" data-test="back">
                <font-awesome-icon :icon="faChevronLeft" class="h-5 w-5 text-gray-400" aria-hidden="true" /> Back
            </inertia-link>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons'

/**
 * 86bc8uyd2: the header on every Applicant Boost page, with the way back to
 * the self credit check.
 */
export default {
    components: {
        FontAwesomeIcon,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            default: '',
        },
        reportId: {
            type: [Number, String],
            required: true,
        },
    },
    setup() {
        return { faChevronLeft }
    },
}
</script>
